import {ELanguage} from "@microfrontends/react-components";

export enum ESplitType {
	'/' = '/',
	'.' = '.'
}

export const dayOfWeekArray = [
	'Chủ nhật',
	'Thứ hai',
	'Thứ ba',
	'Thứ tư',
	'Thứ năm',
	'Thứ sáu',
	'Thứ bảy'
]
export const dayOfWeekArrayEn = [
	'Sun',
	'Mon',
	'Tue',
	'Wed',
	'Thu',
	'Fri',
	'Sat'
]

export function formatDate(date?: string, type?: ESplitType): string {
	if (!date) return ''
	const localeDate = date.split(' ')
	if (!localeDate || localeDate.length < 1) return ''
	const newDate = new Date(localeDate[0])
	const day =
		newDate.getDate() < 10 ? `0${newDate.getDate()}` : newDate.getDate()
	const month =
		newDate.getMonth() + 1 < 10
			? `0${newDate.getMonth() + 1}`
			: newDate.getMonth() + 1
	const year = newDate.getFullYear()
	switch (type) {
		case ESplitType['.']:
			return `${day}.${month}.${year}`
		case ESplitType['/']:
			return `${day}/${month}/${year}`
		default:
			return ''
	}
}

export const formatDateTime = (time, languageCode: ELanguage = ELanguage.VI) => {
	// Create a new date object from the UTC time string
	const date = new Date(time)

	// Get the day, month, and year
	const dayOfWeek = languageCode === ELanguage.EN ? dayOfWeekArrayEn[date.getDay()] : dayOfWeekArray[date.getDay()]
	const day = date.getUTCDate()
	const month = date.getUTCMonth() + 1
	const year = date.getUTCFullYear()

	// Get the time in the format "hh:mm:ss"
	const timeString = date.toISOString().slice(11, 16)

	return {
		dayOfWeek,
		day: day,
		month: month,
		year: year,
		time: timeString
	}
}

export const getCurrentDatetime = () => {
	const today = new Date()

	const day = today.getDate()
	const month = today.getMonth() + 1
	const year = today.getFullYear()
	
	let strDay = day.toString()
	let strMonth = month.toString()
	if (day < 10) {
		strDay = `0${day}`
	}
	if (month < 10) {
		strMonth = `0${month}`
	}

	// Format return: DD/MM/YYYY
	return `${strDay}/${strMonth}/${year}`
}
